import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, switchMap, catchError, retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IpLocationService {
  private testMode: boolean = false;
  private testCountry: string = 'BR';

  constructor(private http: HttpClient) {}

  // Método para ativar o modo de teste
  enableTestMode(country: string = 'US') {
    this.testMode = true;
    this.testCountry = country;
  }

  // Método para desativar o modo de teste
  disableTestMode() {
    this.testMode = false;
    this.testCountry = 'BR';
  }

  private getIpFromIpify(): Observable<string> {
    return this.http.get<any>('https://api.ipify.org?format=json').pipe(
      map(response => response.ip),
      retry(2),
      catchError(() => throwError(() => new Error('Falha ao obter IP do ipify')))
    );
  }

  private getLocationFromIpApi(ip: string): Observable<{ country: string, allowed: boolean, api: string }> {
    return this.http.get<any>(`http://ip-api.com/json/${ip}`).pipe(
      map(response => ({
        country: response.countryCode,
        allowed: response.countryCode === 'BR',
        api: 'ip-api.com'
      })),
      retry(2),
      catchError(() => throwError(() => new Error('Falha ao obter localização do ip-api')))
    );
  }

  private getLocationFromIpapiCo(ip: string): Observable<{ country: string, allowed: boolean, api: string }> {
    return this.http.get<any>(`https://ipapi.co/${ip}/json/`).pipe(
      map(response => ({
        country: response.country_code,
        allowed: response.country_code === 'BR',
        api: 'ipapi.co'
      })),
      retry(2),
      catchError(() => throwError(() => new Error('Falha ao obter localização do ipapi.co')))
    );
  }

  private getLocationFromIpstack(ip: string): Observable<{ country: string, allowed: boolean, api: string }> {
    return this.http.get<any>(`http://api.ipstack.com/${ip}?access_key=YOUR_IPSTACK_KEY`).pipe(
      map(response => ({
        country: response.country_code,
        allowed: response.country_code === 'BR',
        api: 'ipstack.com'
      })),
      retry(2),
      catchError(() => throwError(() => new Error('Falha ao obter localização do ipstack')))
    );
  }

  getIpLocation(): Observable<{ country: string, allowed: boolean, api: string }> {
    if (this.testMode) {
      return of({
        country: this.testCountry,
        allowed: this.testCountry === 'BR',
        api: 'test-mode'
      });
    }

    return this.getIpFromIpify().pipe(
      switchMap(ip => {
        // Tenta cada serviço em sequência
        return this.getLocationFromIpApi(ip).pipe(
          catchError(() => this.getLocationFromIpapiCo(ip)),
          catchError(() => this.getLocationFromIpstack(ip)),
          catchError(() => {
            console.error('Todas as APIs de localização falharam');
            return of({ country: 'Unknown', allowed: false, api: 'none' });
          })
        );
      }),
      catchError(() => {
        console.error('Falha ao obter IP');
        return of({ country: 'Unknown', allowed: false, api: 'none' });
      })
    );
  }
} 